import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { DonutChartComponent } from './donut-chart/donut-chart.component'

@NgModule({
  declarations: [DonutChartComponent],
  imports: [CommonModule],
  exports: [DonutChartComponent],
  providers: [],
})
export class ChartsModule {}
